var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[_vm.$style.voteBtn, {
    [_vm.$style.voteBtnActive]: _vm.isVoted,
  }],attrs:{"type":"button","aria-label":"Нравится","title":"Нравится","disabled":_vm.isVoted},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.vote()}}},[_c('app-icon',{class:_vm.$style.voteBtnIcon,attrs:{"name":"like","paint":['fill']}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.votes.toLocaleString('ru')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }